import {
  useState,
  useEffect,
  useContext,
} from 'react';
import { firestore } from '../../firebase';
import { UseToastsContext } from '../contexts/UseToastsContext';

const useGraduateAccountInfo = (
  id,
  currentName,
  currentSurname,
  currentLinkedinUrl,
  currentDjceCenter,
  currentPromoYear,
  users,
  setUsers,
)  => {
  const {
    setError,
    setSuccess,
    isLoading,
    setIsLoading,
  } = useContext(UseToastsContext);
  const [name, setNameLow] = useState(currentName);
  const [surname, setSurname] = useState(currentSurname);
  const [linkedinUrl, setLinkedinUrl] = useState(currentLinkedinUrl);
  const [djceCenter, setDjceCenter] = useState(currentDjceCenter);
  const [promoYear, setPromoYear] = useState(currentPromoYear);
  const [isDisabled, setIsDisabled] = useState(true);

  const setName = (name) => {
    setNameLow(name.toUpperCase())
  }

  useEffect(
    () => {
      setIsDisabled(
        name.trim() === ''
        || surname.trim() === ''
        || djceCenter.trim() === ''
        || promoYear.trim() === ''
      );
    },
    [name, surname, djceCenter, promoYear],
  );

  const updateGraduateAccountInfo = (): void => {
    if (isLoading || isDisabled) {
      setError({ message: 'fillAllInformation' });
    }
    else {
      setIsLoading(true);
      if (id !== '') {
        firestore.updateUser(
          id,
          {
            surname,
            name: name.toUpperCase(),
            linkedinUrl,
            djceCenter,
            promoYear,
            updatedOn: firestore.createTimeStamp(),
          },
        ).then(() => {
          const newUsers = users;
          let index = -1;
          users.forEach(({ id: userId }, i) => {
            if (userId === id) {
              index = i;
            }
          });
          if (index !== -1) {
            const oldUser = newUsers[index];
            const userUpdated = {
              ...oldUser,
              surname,
              name,
              linkedinUrl,
              djceCenter,
              promoYear,
            };
            newUsers[index] = { ...userUpdated };
            setUsers(newUsers);
          }
          setSuccess({ message: 'infoUpdateSuccess' });
          setIsLoading(false);
        }).catch((e) => {
          setError(e);
          setIsLoading(false);
        });
      } else {
        setError({ message: 'userNotFound' });
        setIsLoading(false);
      }
    }
  };

  return {
    name,
    setName,
    surname,
    setSurname,
    linkedinUrl,
    setLinkedinUrl,
    promoYear,
    setPromoYear,
    djceCenter,
    setDjceCenter,
    isDisabled,
    isLoading,
    updateGraduateAccountInfo,
  };
};

export default useGraduateAccountInfo;
